<template>
  <v-row no-gutters>
    <v-col cols="12" md="12">
      <v-toolbar dark color="primary pl-2 pr-2" density="compact">
        <v-toolbar-title>
          <span v-if="subTitle!=''">{{ subTitle }}</span>
          <span v-else>{{ title }}</span>
          <v-icon size="x-small" @click="editNameChange()">mdi-pencil</v-icon>
        </v-toolbar-title>
          
        <!-- <v-spacer></v-spacer> -->
        <v-btn icon dark @click="closeDialogMethod()">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="12" md="12">
      <v-sheet class="information-window-v-sheet" v-if="keyId == 0">
        <chatting :pageId="pageId" v-if="showChattingMobile == 1" :dialogDisconnect="dialogDisconnect"/>
        <chatting-customer
          :pageId="pageId"
          :refreshChatting="refreshChatting"
          :customerId="customerId"
          v-else-if="showChattingMobile == 2"
          :dialogDisconnect="dialogDisconnect"
        />
      </v-sheet>
      <v-sheet v-else>
        <chatting-friend :dialogDisconnect="dialogDisconnect" />
      </v-sheet>
    </v-col>
    <v-col cols="12" md="12" >
      <v-dialog v-model="nameChangeDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 white--text bg-red">
            Name Change 
          </v-card-title>
          <v-card-subtitle>
            <v-text-field class="mt-3" label="Name Change" v-model="nameChange.profileName" variant="outlined"
              density="compact"/>
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="nameChangeDialog = false">
              CANCEL
            </v-btn>
            <v-btn  class="bg-red"  @click="clickNameChange()">
              Change
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import chatting from "@/components/Chatting.vue";
import ChattingCustomer from "@/components/ChattingCustomer.vue";
import ChattingFriend from './ChattingFriend.vue';
import friService from "../service/FriendService";
export default {
  data: () => ({ dialogDisconnect:0,nameChangeDialog:false,
    nameChange:{},
  loginUser:{},
  storeFriend:{},
  subTitle:"",
}),
  props: {
    pageId: Number,
    title: String,
    showChattingMobile: Number,
    refreshChatting: Number,
    customerId: Number,
    keyId: Number,
  },
  mounted: function () {
    this.loginUser = this.$store.state.userAccountChat;
    this.storeFriend = this.$store.state.friend;
  },
  methods: {
    clickNameChange:function(){
      this.nameChangeDialog = false;
        friService
        .changeFriendName(this.loginUser.userId,this.storeFriend.userAccountId,this.nameChange.profileName)
        .then((response) => {
          this.subTitle = this.nameChange.profileName;
          this.$emit('friendListMethodIndex');
          //this.friendListMethod();
        })
        .catch((error) => {
          
        });
    },
    editNameChange:function(){
      this.nameChangeDialog = true;
      this.nameChange.profileName = this.title;
    },
    closeDialogMethod:function(){
      this.dialogDisconnect= Number(this.dialogDisconnect)+1;
      this.$emit('closeDialog');
    }
  },
  watch: {},
  components: { chatting, ChattingCustomer, ChattingFriend },
};
</script>
<style scoped>
</style>